import { Component, OnInit, ViewContainerRef, ViewChild } from '@angular/core';
import { Http, Response } from '@angular/http';
import { UPLOAD_FILE } from '../models/uploadFile';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { FileUtilC } from './file.util';
import { ConstantsC } from './test.constants';
import * as Globals from '../globals';
import { from } from 'rxjs/observable/from';
import { forEach } from '@angular/router/src/utils/collection';
import { resetFakeAsyncZone } from '@angular/core/testing';
declare var $: any;
const url = Globals.serviceUrl;

@Component({
  selector: 'app-upload-checker',
  templateUrl: './upload-checker.component.html',
  styleUrls: ['./upload-checker.component.css']
})
export class UploadCheckerComponent implements OnInit {

  tab: number = 1;
  param: any;
  loading: boolean;
  p: number = 1;
  userProfile: any;
  authMenu: any;
  @ViewChild("fileImportInput") fileImportInput: any;
  csvRecords: any[];
  csvHeaders: any[];
  jsonRecords: any[];
  jsonRecord: any;
  jmlRecords: number = 0;

  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService, private route: ActivatedRoute, private router: Router, private _fileUtil: FileUtilC) {
    this.toastr.setRootViewContainerRef(vRef);
    this.jsonRecord = {};
    this.authMenu = { M_FLAG: null };
    this.router.events.subscribe(event => {
      if (event instanceof RoutesRecognized) {
        if (event.url == '/uploadchecker/issuance/0') {
          this.tab = 1;
          this.router.navigate(['/uploadchecker/issuance/1']);
        }
      };
    });
  }
  ngOnInit() {
    let id = +this.route.snapshot.params['id'];
    if (id == 0) {
      this.router.navigate(['/upload/issuance/1']);
    }
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.userProfile = this.profileService.userProfile;
    }
  }

  // METHOD CALLED WHEN CSV FILE IS IMPORTED
  fileChangeListener($event): void {
 
    var text = [];
    var files = $event.srcElement.files;
    var result = [];
 
    if(ConstantsC.validateHeaderAndRecordLengthFlag){
      if(!this._fileUtil.isCSVFile(files[0])){
        alert("Please import valid .csv file.");
        this.fileReset();
      }
    }
 
    var input = $event.target;
    var reader = new FileReader();
    reader.readAsText(input.files[0]);
 
    reader.onload = (data) => {
      let csvData = reader.result;
      //split(/\r\n|\n/) --> untuk menghapus row
      //trim() --> untuk memangkas line/row terakhir
      let csvRecordsArray = csvData.trim().split(/\r\n|\n/);
      
      var headerLength = -1;
      if(ConstantsC.isHeaderPresentFlag){
        let headersRow = this._fileUtil.getHeaderArray(csvRecordsArray, ConstantsC.tokenDelimeter);
        headerLength = headersRow.length;
        this.csvHeaders = headersRow;
      }
      this.csvRecords = this._fileUtil.getDataRecordsArrayFromCSVFile(csvRecordsArray, 
          headerLength, ConstantsC.validateHeaderAndRecordLengthFlag, ConstantsC.tokenDelimeter);
       
      if(this.csvRecords == null){
        //If control reached here it means csv file contains error, reset file.
        this.fileReset();
      }
      
      for (var i = 1; i < this.csvRecords.length; i++) {
        var obj = {};
        var currentLine = this.csvRecords[i];
        for(var p = 0; p < this.csvHeaders.length; p++){
            obj[this.csvHeaders[p]] = currentLine[p];
        }
        result.push(obj);
      }
      
      var jsonData = JSON.parse(JSON.stringify(result));
      this.jsonRecords = jsonData;
      this.jmlRecords = this.jsonRecords.length;
      //console.log(this.jsonRecords);
      
    }

    reader.onerror = function () {
      alert('Unable to read ' + input.files[0]);
    };
  };

  View(item: any) {
    this.jsonRecord = item;
  }
 
  fileReset(){
    this.fileImportInput.nativeElement.value = "";
    this.jsonRecords = [];
    this.jmlRecords = 0;
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/upload-checker/upload-checker.component.ts